export default "__VITE_ASSET___bAdUBTT__"